"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatConsumptionText = formatConsumptionText;
exports.formatDischargedConsumptionText = formatDischargedConsumptionText;
const transform_types_1 = require("../types/transform.types");
const vehicleKey_1 = require("../utils/vehicleKey");
const constants_1 = require("./constants");
const mustacheRenderer_1 = require("./renderer/mustacheRenderer");
const utils_1 = require("./utils");
function formatConsumptionText(resources, vehicleType, fuelEntry) {
    var _a, _b, _c, _d, _e, _f;
    let view;
    if (vehicleType === transform_types_1.VehicleTypeEnum.OVCHEV) {
        const nonElectricalFuel = (0, utils_1.getNonElectricalFuel)(fuelEntry);
        const electricalFuel = (0, utils_1.getElectricalFuel)(fuelEntry);
        view = {
            consumption0: {
                fuel: resources.get((_a = `vue.${electricalFuel === null || electricalFuel === void 0 ? void 0 : electricalFuel.fuel}`) !== null && _a !== void 0 ? _a : ""),
                wltp: {
                    combined: (0, utils_1.getConsumptionOrEmissionNumericValue)(electricalFuel === null || electricalFuel === void 0 ? void 0 : electricalFuel.consumption, "WLTP", "combined"),
                },
                nedc: {
                    combined: (0, utils_1.getConsumptionOrEmissionNumericValue)(electricalFuel === null || electricalFuel === void 0 ? void 0 : electricalFuel.consumption, "NEDC", "combined"),
                },
            },
            consumption1: {
                fuel: resources.get((_b = `vue.${nonElectricalFuel === null || nonElectricalFuel === void 0 ? void 0 : nonElectricalFuel.fuel}`) !== null && _b !== void 0 ? _b : ""),
                wltp: {
                    combined: (0, utils_1.getConsumptionOrEmissionNumericValue)(nonElectricalFuel === null || nonElectricalFuel === void 0 ? void 0 : nonElectricalFuel.consumption, "WLTP", "combined"),
                },
                nedc: {
                    combined: (0, utils_1.getConsumptionOrEmissionNumericValue)(nonElectricalFuel === null || nonElectricalFuel === void 0 ? void 0 : nonElectricalFuel.consumption, "NEDC", "combined"),
                },
            },
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        };
    }
    else {
        view = {
            consumption0: {
                fuel: resources.get((_d = `vue.${(_c = fuelEntry === null || fuelEntry === void 0 ? void 0 : fuelEntry[0]) === null || _c === void 0 ? void 0 : _c.fuel}`) !== null && _d !== void 0 ? _d : ""),
                wltp: {
                    combined: (0, utils_1.getConsumptionOrEmissionNumericValue)((_e = fuelEntry === null || fuelEntry === void 0 ? void 0 : fuelEntry[0]) === null || _e === void 0 ? void 0 : _e.consumption, "WLTP", "combined"),
                },
                nedc: {
                    combined: (0, utils_1.getConsumptionOrEmissionNumericValue)((_f = fuelEntry === null || fuelEntry === void 0 ? void 0 : fuelEntry[0]) === null || _f === void 0 ? void 0 : _f.consumption, "NEDC", "combined"),
                },
            },
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        };
    }
    //If NEDC values are not set, then set the WLTP value in the combined field
    //For WLTP we must also display the suffix at the end of the formatted text
    if ((view.consumption0.nedc === undefined || view.consumption0.nedc.combined === undefined) &&
        view.consumption0.wltp !== undefined) {
        view.consumption0.combined = view.consumption0.wltp.combined;
        view.consumption0.nedc = { combined: view.consumption0.wltp.combined };
    }
    else if (view.consumption0.nedc !== undefined) {
        view.consumption0.combined = view.consumption0.nedc.combined;
    }
    if (view.consumption1 !== undefined) {
        if ((view.consumption1.nedc === undefined || view.consumption1.nedc.combined === undefined) &&
            view.consumption1.wltp !== undefined) {
            view.consumption1.combined = view.consumption1.wltp.combined;
            view.consumption1.nedc = { combined: view.consumption1.wltp.combined };
        }
        else if (view.consumption1.nedc !== undefined) {
            view.consumption1.combined = view.consumption1.nedc.combined;
        }
    }
    if (!vehicleType) {
        return undefined;
    }
    const translationKey = (0, vehicleKey_1.getTranslationKeyForVehicleType)("vue.consumption.combined", vehicleType);
    return (0, mustacheRenderer_1.substituteTemplate)(resources.get(translationKey), view);
}
function formatDischargedConsumptionText(resources, vehicleType, fuelEntry) {
    //return undefined, if it is _not_ a hybrid
    if (vehicleType !== transform_types_1.VehicleTypeEnum.OVCHEV) {
        return undefined;
    }
    const view = {
        consumption: {
            fuel: getDischargedValue(fuelEntry),
        },
        footnote: {
            reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
        },
    };
    return (0, mustacheRenderer_1.substituteTemplate)(resources.get("vue.consumption.combined.hybrid.discharged"), view);
}
function getDischargedValue(fuelEntry) {
    var _a, _b, _c, _d;
    let dischargedValue = "";
    const nonElectricalFuelEntry = fuelEntry === null || fuelEntry === void 0 ? void 0 : fuelEntry.find((entry) => entry.fuel != "ELECTRICAL");
    if (nonElectricalFuelEntry != undefined) {
        if (((_b = (_a = nonElectricalFuelEntry.consumption) === null || _a === void 0 ? void 0 : _a.wltp) === null || _b === void 0 ? void 0 : _b.dataSets) !== undefined) {
            const sustainingDataSet = nonElectricalFuelEntry.consumption.wltp.dataSets.find((dataSet) => dataSet.em === "SUSTAINING");
            if (sustainingDataSet) {
                dischargedValue = ((_d = (_c = sustainingDataSet.values) === null || _c === void 0 ? void 0 : _c.combined) === null || _d === void 0 ? void 0 : _d.formatted) || "";
            }
        }
    }
    return dischargedValue;
}
